import React, { useState } from 'react';
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Spinner,
} from 'react-bootstrap';
import { FaSave, FaTimes } from 'react-icons/fa';
import { createCustomerConnection } from '../services/customerService';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const showToast = (type, message) => {
  const configs = {
    success: { color: "#28a745", border: "2px solid #28a745" },
    error: { color: "#dc3545", border: "2px solid #dc3545" },
    warning: { color: "#ffc107", border: "2px solid #ffc107" },
    info: { color: "#17a2b8", border: "2px solid #17a2b8" },
  };
  const config = configs[type];
  toast[type](message, {
    position: "top-right",
    autoClose: 3000,
    transition: Bounce,
    style: {
      border: config.border,
      background: "transparent",
      color: config.color,
      boxShadow: "none",
      marginTop: "70px",
    },
    icon: false,
  });
};

const CreateConnectionModal = ({ show, onHide, customerId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    gas_type: 'lpg',
    cylinder_capacity: '14.2kg',
    connection_date: new Date().toISOString().split('T')[0],
    security_deposit: 0,
    regulator_number: '',
    stove_details: '',
    connection_status: 'active',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...formData,
        customer_id: customerId,
        connection_number: `CONN_${Date.now()}`,
      };

      await createCustomerConnection(payload);
      showToast('success', 'Connection created successfully! 🎉');
      
      setFormData({
        gas_type: 'lpg',
        cylinder_capacity: '14.2kg',
        connection_date: new Date().toISOString().split('T')[0],
        security_deposit: 0,
        regulator_number: '',
        stove_details: '',
        connection_status: 'active',
      });
      
      if (onSuccess) onSuccess();
      onHide();
    } catch (error) {
      showToast('error', error.response?.data?.message || 'Failed to create connection');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} transition={Bounce} />
      
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Connection</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Gas Type</Form.Label>
                  <Form.Select
                    name="gas_type"
                    value={formData.gas_type}
                    onChange={handleChange}
                  >
                    <option value="lpg">LPG</option>
                    <option value="png">PNG</option>
                    <option value="cng">CNG</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Cylinder Capacity</Form.Label>
                  <Form.Select
                    name="cylinder_capacity"
                    value={formData.cylinder_capacity}
                    onChange={handleChange}
                  >
                    <option value="5kg">5kg</option>
                    <option value="14.2kg">14.2kg</option>
                    <option value="19kg">19kg</option>
                    <option value="47.5kg">47.5kg</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Connection Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="connection_date"
                    value={formData.connection_date}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Security Deposit (₹)</Form.Label>
                  <Form.Control
                    type="number"
                    name="security_deposit"
                    value={formData.security_deposit}
                    onChange={handleChange}
                    min="0"
                    step="100"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Regulator Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="regulator_number"
                    value={formData.regulator_number}
                    onChange={handleChange}
                    placeholder="Enter regulator number"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="connection_status"
                    value={formData.connection_status}
                    onChange={handleChange}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="suspended">Suspended</option>
                    <option value="pending">Pending</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label>Stove Details</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="stove_details"
                    value={formData.stove_details}
                    onChange={handleChange}
                    placeholder="Enter stove details"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
              <FaTimes className="me-2" /> Cancel
            </Button>
            <Button
              type="submit"
              disabled={loading}
              style={{
                backgroundColor: "rgb(30, 58, 111)",
                border: "none",
                borderRadius: "30px",
                padding: "10px 24px",
              }}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <><FaSave className="me-2" /> Create Connection</>
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default CreateConnectionModal;